import script from "./CreateTestsWriter.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateTestsWriter.vue?vue&type=script&setup=true&lang=js"

import "./CreateTestsWriter.vue?vue&type=style&index=0&id=7357c8ee&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7357c8ee"]])

export default __exports__